import styled from "styled-components";

import { PressContainerBodyLabel } from "../SimilarPressTableContainer/SimilarPressTableContainer.style";

export const TooltipWrapper = styled.div`
  ${PressContainerBodyLabel}
  position: fixed;
  width: 34.4rem;
  height: fit-content;
  border-radius: var(--Border-Radius-4, 0.4rem);
  border: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16),
    0px 0px 2px 0px rgba(0, 0, 0, 0.12);
  background: var(--Color-Common-Bg-Primary, #fff);
  display: flex;
  padding: var(--Spacing-4, 0.4rem) var(--Spacing-8, 0.8rem);
  z-index: 10000;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: var(--Spacing-4, 0.4rem);
  word-break: keep-all;
  pointer-events: none;

  & * {
    font-family: var(--font-pt-serif);
  }
`;

export const EllipsisIndicator = styled.div`
  ${PressContainerBodyLabel}
  padding: var(--Spacing-2, 0.2rem) var(--Spacing-6, 0.6rem);
  color: var(--Color-Common-Text-Tertiary, #7c899c);
`;

export const OverflowContainer = styled.div`
  ${PressContainerBodyLabel}
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
`;

export const LineClampContainer = styled.div<{ maxLines: number }>`
  ${PressContainerBodyLabel}
  padding: var(--Spacing-2, 0.2rem) var(--Spacing-6, 0.6rem);
  display: -webkit-box;
  -webkit-line-clamp: ${({ maxLines }) => maxLines};
  -webkit-box-orient: vertical;
  overflow: hidden;
  width: 100%;
`;
